// src/components/personal/RotationWorkshiftsPicker.jsx
//
// Selector de turnos permitidos para "Rotación restringida": la persona solo
// va a rotar entre los turnos que se elijan acá (personal_rotation_workshift
// en la base). Las opciones son los turnos habilitados de la estación
// seleccionada (globales + locales), el mismo listado que ya se usa para el
// horario fijo semanal (stationWorkshifts).

import React from 'react';
import { formatWorkshiftLabel } from './workshiftLabel';
import { Autocomplete, TextField } from '@mui/material';

const RotationWorkshiftsPicker = ({
  workshifts = [],
  value = [],
  onChange,
  disabled = false,
  error,
  helperText,
}) => (
  <Autocomplete
    multiple
    disableCloseOnSelect
    options={workshifts}
    getOptionLabel={formatWorkshiftLabel}
    isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
    value={value}
    onChange={(_, newValue) => onChange(newValue || [])}
    disabled={disabled}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Turnos permitidos para rotar"
        error={error}
        helperText={
          error
            ? helperText
            : (helperText || (workshifts.length === 0
                ? 'Los turnos disponibles se cargan según la estación seleccionada.'
                : undefined))
        }
      />
    )}
  />
);

export default RotationWorkshiftsPicker;
